import { render, staticRenderFns } from "./ActualizacionDespacho.vue?vue&type=template&id=5ee06cbb&"
import script from "./ActualizacionDespacho.vue?vue&type=script&lang=js&"
export * from "./ActualizacionDespacho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports